import events from 'events-bus';
import { ReactNode, useEffect, useState } from 'react';

import { initAxios, syncToken } from '../services/api';

const KeycloakTokenProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const [keycloakTokenLoaded, setKeycloakTokenLoaded] = useState(false);

  useEffect(() => {
    initAxios();
  }, []);

  useEffect(() => {
    const tokenListener = (_: any, data: { token: string }) => {
      const token = data.token;
      syncToken(token);
      setKeycloakTokenLoaded(!!token);
    };
    events.on('AUTH-SUCCESS-EVENT-v1', tokenListener);
    return () => {
      events.off(tokenListener);
    };
  }, []);

  if (!keycloakTokenLoaded) {
    return null;
  }

  return <>{children}</>;
};

export default KeycloakTokenProvider;
